export default __webpack_public_path__ + "static/assets/med_pill_rectangle_out_L1_solid_x_01_f.f4b98e4f.png";